import React, { useState, useEffect } from "react";
import { SegmentControl, Select } from "../../../groundworkui-ui";
import ColorPackPickerModal from "./color_pack_picker_modal";
import {
  aestheticOptions,
  borderRadiusOptions,
  boxShadowOptions,
  fontFamilyOptions,
  findOptionByValue,
} from "../../../utilities/options_helpers";

const Setting = ({ children }) => {
  return <div className="flex flex-col gap-1">{children}</div>;
};

const Settings = ({ initialUiKitConfiguration, onChange }) => {
  const [selectedBorderRadiusOption, setSelectedBorderRadiusOption] = useState(
    findOptionByValue(
      borderRadiusOptions,
      initialUiKitConfiguration.border_radius,
    ) || borderRadiusOptions[0],
  );
  const [colors, setColors] = useState(initialUiKitConfiguration.colors);

  const [showColorPackModal, setShowColorPackModal] = useState(false);

  const [selectedAestheticOption, setSelectedAestheticOption] = useState(
    findOptionByValue(aestheticOptions, initialUiKitConfiguration.aesthetic) ||
      aestheticOptions[0],
  );

  const [selectedBoxShadowOption, setSelectedBoxShadowOption] = useState(
    findOptionByValue(boxShadowOptions, initialUiKitConfiguration.box_shadow) ||
      boxShadowOptions[0],
  );

  const [selectedFontFamilyOption, setSelectedFontFamilyOption] = useState(
    findOptionByValue(
      fontFamilyOptions,
      initialUiKitConfiguration.font_family,
    ) || fontFamilyOptions[0],
  );

  useEffect(() => {
    onChange({
      border_radius: selectedBorderRadiusOption.value,
      colors,
      aesthetic: selectedAestheticOption.value,
      box_shadow: selectedBoxShadowOption.value,
      font_family: selectedFontFamilyOption.value,
    });
  }, [
    selectedBorderRadiusOption,
    colors,
    selectedAestheticOption,
    selectedBoxShadowOption,
    selectedFontFamilyOption,
  ]);

  return (
    <div className="flex flex-col gap-6">
      <Setting>
        <div>Color Pack</div>
        <div onClick={() => setShowColorPackModal(true)}>
          {colors && Object.keys(colors).length > 0 ? (
            <div className="flex">
              {["primary", "success", "info", "warning", "danger"].map(
                (colorType) => (
                  <div
                    key={colorType}
                    className="h-4 w-8"
                    style={{
                      backgroundColor: colors[`color-${colorType}-500`],
                    }}
                  ></div>
                ),
              )}
            </div>
          ) : (
            <div className="font-bold">(Click to select)</div>
          )}
        </div>
      </Setting>
      <Setting>
        <div>Aesthetic</div>
        <SegmentControl
          options={aestheticOptions}
          selectedOption={selectedAestheticOption}
          onChange={(newOption) => setSelectedAestheticOption(newOption)}
        />
      </Setting>
      <Setting>
        <div>Roundness</div>
        <SegmentControl
          options={borderRadiusOptions}
          selectedOption={selectedBorderRadiusOption}
          onChange={(newOption) => setSelectedBorderRadiusOption(newOption)}
        />
      </Setting>
      <Setting>
        <div>Font</div>
        <Select
          options={fontFamilyOptions}
          value={selectedFontFamilyOption}
          onChange={(newOption) => setSelectedFontFamilyOption(newOption)}
        />
      </Setting>
      <Setting>
        <div>Shadows</div>
        <SegmentControl
          options={boxShadowOptions}
          selectedOption={selectedBoxShadowOption}
          onChange={(newOption) => setSelectedBoxShadowOption(newOption)}
        />
      </Setting>

      {showColorPackModal && (
        <ColorPackPickerModal
          onClose={() => setShowColorPackModal(false)}
          onColorPackSelect={(colorPack) => {
            setColors(colorPack.colors);
            setShowColorPackModal(false);
          }}
        />
      )}
    </div>
  );
};

export default Settings;
